import { useState, useEffect, useMemo } from 'react'
import { getTranslated } from "../../utils/CommonUtils"
import { useSelector } from "react-redux"
import StepsNav from '../common/StepsNav'
//import { getSIPProfileList } from "../../store/actions/SIPActions"
//import { getRequest, postRequest } from "../../utils/RequestActions"
import ProfileSelection from "./ProfileSelection"
import SIPParameters from "./SIPParameters"
import SummaryPage from './Summary'
import VAAGateway from './VAAGateway'
import VNATrunk from './VNATrunk'
import PrefixParameters from './PrefixParameters'
import ACDConfig from './ACDConfig'
import RSIConfig from './RSIConfig'
import DCGWARSPrefix from './DCGWARSPrefix'

//==============
// Default page
//==============
const DefaultPage = () => {
    return <h1>Error 404: Page not found.</h1>;
}

// Wizard page sequence for steps
const renderSteps = (props) => {
    const {
        activeStep,
        managePreviousButton,
        manageNextButton,
        activeProfile,
        selectedProfile,
        prerequisites,
        currentType,
        setCurrentType,
        configurationData, 
        setConfigurationData,
        sipTrunkConfig,
        setTrunkConfig,
        onFinish
    } = props;

    switch (activeStep) {
        case 0:
            return (
                <ProfileSelection
                    onPrevious={managePreviousButton}
                    onNext={manageNextButton}
                    activeProfile={activeProfile}
                    selectedProfile={selectedProfile}
                    prerequisites={prerequisites}
                    currentType={currentType}
                    setCurrentType={setCurrentType}
                />
            );
        case 1:
            return (
                <SIPParameters
                    onPrevious={managePreviousButton}
                    onNext={manageNextButton}
                    activeProfile={activeProfile}
                    setTrunkConfig={setTrunkConfig}
                />
            );
        case 2:
            return (
                <SummaryPage
                    onNext={manageNextButton}
                    activeProfile={activeProfile}
                    sipTrunkConfig={sipTrunkConfig}
                    prerequisites={prerequisites}
                    onFinish={onFinish}
                />
            );
        default:
            return <DefaultPage />;
    }
}

// Wizard page sequence for VAA steps
const renderVAASteps = (props) => {
    const {
        activeStep,
        managePreviousButton,
        manageNextButton,
        activeProfile,
        selectedProfile,
        prerequisites,
        currentType,
        setCurrentType,
        configurationData, 
        setConfigurationData,
        sipTrunkConfig,
        setTrunkConfig,
        onFinish
    } = props;
    switch (activeStep) {
        case 0:
            return (
                <ProfileSelection
                    onPrevious={managePreviousButton}
                    onNext={manageNextButton}
                    activeProfile={activeProfile}
                    selectedProfile={selectedProfile}
                    prerequisites={prerequisites}
                    currentType={currentType}
                    setCurrentType={setCurrentType}
                />
            );
        case 1:
            return (
                <VAAGateway
                    onPrevious={managePreviousButton}
                    onNext={manageNextButton}
                    activeProfile={activeProfile}
                    trunkConfig={sipTrunkConfig}
                    setTrunkConfig={setTrunkConfig}
                    configurationData={configurationData}
                    setConfigurationData={setConfigurationData}
                />
            );
        case 2:
            return (
                <PrefixParameters
                    onPrevious={managePreviousButton}
                    onNext={manageNextButton}
                    activeProfile={activeProfile}
                    trunkConfig={sipTrunkConfig}
                    setTrunkConfig={setTrunkConfig}
                    configurationData={configurationData}
                    setConfigurationData={setConfigurationData}
                />
            );
        case 3:
            return (
                <SummaryPage
                    onNext={manageNextButton}
                    activeProfile={activeProfile}
                    sipTrunkConfig={sipTrunkConfig}
                    prerequisites={prerequisites}
                    onFinish={onFinish}
                />
            );
        default:
            return <DefaultPage />;
    }
}

// Wizard page sequence for VNA steps
const renderVNASteps = (props) => {
    const {
        activeStep,
        managePreviousButton,
        manageNextButton,
        activeProfile,
        selectedProfile,
        prerequisites,
        currentType,
        setCurrentType,
        configurationData, 
        setConfigurationData,
        sipTrunkConfig,
        setTrunkConfig,
        onFinish
    } = props;
    switch (activeStep) {
        case 0:
            return (
                <ProfileSelection
                    onPrevious={managePreviousButton}
                    onNext={manageNextButton}
                    activeProfile={activeProfile}
                    selectedProfile={selectedProfile}
                    prerequisites={prerequisites}
                    currentType={currentType}
                    setCurrentType={setCurrentType}
                />
            );
        case 1:
            return (
                <VNATrunk
                    onPrevious={managePreviousButton}
                    onNext={manageNextButton}
                    activeProfile={activeProfile}
                    trunkConfig={sipTrunkConfig}
                    setTrunkConfig={setTrunkConfig}
                    configurationData={configurationData}
                    setConfigurationData={setConfigurationData}
                />
            );
        case 2:
            return (
                <PrefixParameters
                    onPrevious={managePreviousButton}
                    onNext={manageNextButton}
                    activeProfile={activeProfile}
                    trunkConfig={sipTrunkConfig}
                    setTrunkConfig={setTrunkConfig}
                    configurationData={configurationData}
                    setConfigurationData={setConfigurationData}
                />
            );
        case 3:
            return (
                <SummaryPage
                    onNext={manageNextButton}
                    activeProfile={activeProfile}
                    sipTrunkConfig={sipTrunkConfig}
                    prerequisites={prerequisites}
                    onFinish={onFinish}
                />
            );
        default:
            return <DefaultPage />;
    }
}

// Wizard page sequence for Dispatch console steps
const renderDCSteps = (props) => {
    const {
        activeStep,
        managePreviousButton,
        manageNextButton,
        activeProfile,
        selectedProfile,
        prerequisites,
        currentType,
        setCurrentType,
        configurationData, 
        setConfigurationData,
        sipTrunkConfig,
        setTrunkConfig,
        onFinish
    } = props;
    switch (activeStep) {
        case 0:
            return (
                <ProfileSelection
                    onPrevious={managePreviousButton}
                    onNext={manageNextButton}
                    activeProfile={activeProfile}
                    selectedProfile={selectedProfile}
                    prerequisites={prerequisites}
                    currentType={currentType}
                    setCurrentType={setCurrentType}
                />
            );
        case 1:
            return (
                <ACDConfig
                    onPrevious={managePreviousButton}
                    onNext={manageNextButton}
                    activeProfile={activeProfile}
                    trunkConfig={sipTrunkConfig}
                    setTrunkConfig={setTrunkConfig}
                    configurationData={configurationData}
                    setConfigurationData={setConfigurationData}
                />
            );
        case 2:
            return (
                <RSIConfig
                    onPrevious={managePreviousButton}
                    onNext={manageNextButton}
                    activeProfile={activeProfile}
                    trunkConfig={sipTrunkConfig}
                    setTrunkConfig={setTrunkConfig}
                    configurationData={configurationData}
                    setConfigurationData={setConfigurationData}
                />
            );
        case 3:
            return (
                <DCGWARSPrefix
                    onPrevious={managePreviousButton}
                    onNext={manageNextButton}
                    activeProfile={activeProfile}
                    trunkConfig={sipTrunkConfig}
                    setTrunkConfig={setTrunkConfig}
                    configurationData={configurationData}
                    setConfigurationData={setConfigurationData}
                />
            );
        case 4:
            return (
                <SummaryPage
                    onNext={manageNextButton}
                    activeProfile={activeProfile}
                    sipTrunkConfig={sipTrunkConfig}
                    prerequisites={prerequisites}
                    onFinish={onFinish}
                />
            );
        default:
            return <DefaultPage />;
    }
}

// Render wizard steps based on profile type
const renderStepContent = (props) => {
    switch (props.currentType) {
        case 'Visual AA':
            return renderVAASteps(props);
        case 'Visual NA':
            return renderVNASteps(props);
        case 'public':
        case 'WebRTC':
            return renderSteps(props);
        case 'Dispatch':
            return renderDCSteps(props);
        default:
            return <DefaultPage />;
    }
};

///////////////////////////////////////////////
// Wizard management to create a new SIP trunk
///////////////////////////////////////////////
const Wizard = ({ onFinish, prerequisites }) => {
    const [activeProfile, setActiveProfile] = useState({});
    const [activeStep, setActiveStep] = useState(0);

    const [configurationData, setConfigurationData] = useState({}); // Data parameters to display
    const [sipTrunkConfig, setSipTrunkConfig] = useState({});   // Data to transmit

    const dict = useSelector((state) => state.common.dict);

    // Page names for wizard pages
    const steps = useMemo(() => [
        { title: getTranslated(dict, 'LABEL_PROFILE') },
        { title: getTranslated(dict, 'LABEL_SIP_PARAMETERS') },
        { title: getTranslated(dict, 'LABEL_STATUS') }
    ], [dict]);

    const stepsVAA = useMemo(() => [
        { title: getTranslated(dict, 'LABEL_PROFILE') },
        { title: getTranslated(dict, 'LABEL_GATEWAY') },
        { title: getTranslated(dict, 'LABEL_PREFIX_PLAN') },
        { title: getTranslated(dict, 'LABEL_STATUS') }
    ], [dict]);

    const stepsVNA = useMemo(() => [
        { title: getTranslated(dict, 'LABEL_PROFILE') },
        { title: getTranslated(dict, 'LABEL_TRUNK') },
        { title: getTranslated(dict, 'LABEL_PREFIX_PLAN') },
        { title: getTranslated(dict, 'LABEL_STATUS') }
    ], [dict]);

    const stepsDispatch = useMemo(() => [
        { title: getTranslated(dict, 'LABEL_PROFILE') },
        { title: getTranslated(dict, 'LABEL_ACDCONFIG') },
        { title: getTranslated(dict, 'LABEL_RSICONFIG') },
        { title: getTranslated(dict, 'LABEL_GWARSPREFIX') },
        { title: getTranslated(dict, 'LABEL_STATUS') }
    ], [dict]);

    // Current type of profile
    const [currentType, setCurrentType] = useState("public");
    const [stepsDefinition, setStepsDefinition] = useState(steps);

    useEffect(() => {
        let wizardSchema;

        switch (currentType) {
            case "Visual AA": wizardSchema = stepsVAA; 
            break;
            case "Visual NA": wizardSchema = stepsVNA; 
            break;
            case "Dispatch": wizardSchema = stepsDispatch;
            break
            default: wizardSchema = steps; 
            break;
        }

        // Compare to detect differences
        const isSameSchema = wizardSchema.length === stepsDefinition.length &&
            wizardSchema.every((step, i) => step.title === stepsDefinition[i]?.title);

        if (!isSameSchema) {
            setStepsDefinition(wizardSchema);
        }
    }, [currentType, steps, stepsVAA, stepsVNA, stepsDispatch, stepsDefinition]);

    // Reset the config on profile selection page
    useEffect(() => {
        if (activeStep === 0) {
            setConfigurationData({});
        }
    }, [activeStep]);

    // Manage the Previous button
    function managePreviousButton() {
        if (activeStep === 0) {
            onFinish();
        }
        else {
            setActiveStep(activeStep !== 0 ? activeStep - 1 : 0);
        }
    }

    // Manage the Next button
    function manageNextButton(val = 0) {
        const delta = val === 0 ? 1 : val;
        setActiveStep(Math.max(0, Math.min(activeStep + delta, stepsDefinition.length)));
    }

    // Keep the name of the selected profile for the next pages
    function selectedProfile(val) {
        setActiveProfile(val);
    }

    // Contains the result of the configuration
    function setTrunkConfig(val) {
        setSipTrunkConfig(val);
    }

    return (
        <div className="sip-content-page">
            <StepsNav
                className="sip-step"
                percent={99}
                current={activeStep}
                items={stepsDefinition}
            />
            <section className="profile-layout">
                {renderStepContent({
                    activeStep,
                    managePreviousButton,
                    manageNextButton,
                    activeProfile,
                    selectedProfile,
                    prerequisites,
                    currentType,
                    setCurrentType,
                    configurationData, 
                    setConfigurationData,
                    sipTrunkConfig,
                    setTrunkConfig,
                    onFinish
                })}
            </section>
        </div>);
}

export default Wizard;